import { render, staticRenderFns } from "./integrityResult.vue?vue&type=template&id=315962ae&scoped=true"
import script from "./integrityResult.vue?vue&type=script&lang=js"
export * from "./integrityResult.vue?vue&type=script&lang=js"
import style0 from "./integrityResult.vue?vue&type=style&index=0&id=315962ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315962ae",
  null
  
)

export default component.exports